import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCustomerProfileViewStore = defineStore('customerProfileView', () => {
	const state = {
		modalsConditions: ref({
			nip: {
				isChecked: false,
				wasShown: false,
			},
			expressPhoto: {
				isChecked: false,
				wasShown: false,
			},
			promotionalAP: {
				isChecked: false,
				wasShown: false,
			},
		}),
		isInRecommendationPromotion: ref(false),
		recommendationPromotionEndDate: ref(''),
		isInApPromotionalCampaign: ref(false),
		isVueRouterView: ref(false),
		selectedOfferId: ref(0),
		selectedCategory: ref({}),
		selectedService: ref(0),
		selectedPhoto: ref({}),
		isSaveProfileTriggered: ref(false),
		updatingField: ref(''),
		savingStatus: ref(''),
		showCertificatesBadgesStickers: ref(false),
		isGusDataFilled: ref(false),
		isFormChanged: ref(false),
		isDataShouldSubmit: ref(false),
		nextRouteNameAttempt: ref(''),
		isReviewsSendLinkModalVisible: ref(false),
	};

	const actions = {
		async inApPromotionalCampaign() {
			try {
				const response = await fetch('/customer/in-ap-promotional-campaign.do');
				const data = await response.json();
				state.isInApPromotionalCampaign.value = data.inApPromotionalCampaign;
			} catch (error) {
				console.error('Error in customerProfileView.ts:', error);
			}
		},
		triggerSaveProfile() {
			state.isSaveProfileTriggered.value = !state.isSaveProfileTriggered.value;
		},
	};

	const getters = {};

	return { ...state, ...actions, ...getters };
});
